const lightShades = [


  "#cc5500",
  "#c19a6b",
  "#ffdb58",
  "#5c5a57",
  "#fff68f",
]
const darkShades = [

  "#cd7f32",
  "#654321",
  "#ffd700",
  " #4a4845",
  "#d4de70",

]


 export function getRandomColor(index: number) {

return {randomLightColor:  lightShades[index], randomDarkColor: darkShades[index]}
    
  }
